import React from 'react';
import {Link} from 'react-router-dom';
import { Grid, Image, Row, Col } from 'react-bootstrap';
import '../styles/css/mainpage.css';
import Logo from '../static/edgelogo.png';
import Footer from '../components/Footer';
import Spinner from '../components/Spinner';

const Courses = ({courses, onClick}) =>{
  return(
    <div className="content_container">
      {courses.map((course,index)=>(
        <Row key={course.name} style={{backgroundImage: 'url('+course.wallpaper+')'}} >
          <Col xs={12}>
            <div className="content">
              <Row>
                <Col xs={12}>
                  <span>{course.name.toUpperCase()}</span>
                </Col>
              </Row>
              <Row className="subtitle">
                <Col xs={12}>
                  {course.is_active?
                    <Link className="btn" to="/dashboard"
                    onClick={()=>onClick(course.id)}>
                    <i className="glyphicon glyphicon-menu-right"/><span>はじめよう</span></Link>:
                    <span style={{fontSize:'16px'}}>Coming Soon</span>
                  }
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      ))}
    </div>
  )
}

const Home = ({courses, onClick}) =>{
  return(
    <Grid className="main_container">
      <div className="top_nav">
        <div className="nav_header">
          <Image className="brand-img logo_img" src={Logo} />
        </div>
      </div>
      {courses?<Courses courses={courses} onClick={onClick} />:<Spinner />}
      <Footer />
    </Grid>
  )
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js